
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M186.67,386.39v98.94a16,16,0,0,0,28.88,9.48L273.43,416Z","fill":"#fff"}}),_c('path',{attrs:{"d":"M505.28,13.63a16,16,0,0,0-16.68-1.15L8.6,263.15a16,16,0,0,0,2.22,29.33l133.44,45.61,284.18-243L208.53,360l223.64,76.44a16.46,16.46,0,0,0,5.16.85,16,16,0,0,0,15.83-13.63L511.83,29A16,16,0,0,0,505.28,13.63Z","fill":"#fff"}})])
      }
    
      }
    